var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 63 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79289 6.29289C10.1834 5.90237 10.8166 5.90237 11.2071 6.29289L18.2071 13.2929C18.5976 13.6834 18.5976 14.3166 18.2071 14.7071L11.2071 21.7071C10.8166 22.0976 10.1834 22.0976 9.79289 21.7071C9.40237 21.3166 9.40237 20.6834 9.79289 20.2929L16.0858 14L9.79289 7.70711C9.40237 7.31658 9.40237 6.68342 9.79289 6.29289Z",
    fill: "#6D757D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.868c996fdfa22ab72a706a738f27bfa5.svg";
export { ForwardRef as ReactComponent };